<template>
  <div>
    <div class="approvalList" v-if="Object.keys(userInfo).length > 0">
      <ld-header v-if="index == 1">
        <template #left>
          <span class="font24 font-bold">
            <span v-show="totalCount > 0">待办({{ lingthList || 0 }})</span>
            <span v-show="totalCount == 0">暂无待办</span>
          </span>
        </template>
      </ld-header>
      <ld-header v-else-if="index == 2">
        待我审批
      </ld-header>
      <ld-header v-else-if="index == 3">
        我提交的审批
      </ld-header>

      <van-tabs
        v-model="active"
        @change="changeTab"
        line-width="20px"
        line-height="2px"
        animated
        swipeable
        sticky
      >
        <van-tab name="1">
          <template #title>
            <span v-if="index == 1 || index == 2">待我审批</span>
            <span v-else-if="index == 3">审批中</span>
            ({{ approvalPage.total }})
          </template>
          <div class="wrapper">
            <mescroll-vue :up="{ use: true, callback: onRefresh }">
              <approval-list-item
                :list="list"
                v-for="(list, i) in approvalList"
                :key="i"
                @to-order-detail="toOrderDetail"
                @to-approval-detail="goApprovalingDetail"
              >
                <van-row
                  v-if="index == 1 || index == 2"
                  slot="footer"
                  type="flex"
                  justify="end"
                  gutter="8"
                >
                  <van-col span="6">
                    <ld-button
                      defaults
                      size="sm"
                      style="width:70px"
                      @click="approvalShow('Reject', list.vipBpmForMyAppDtoList[0])"
                      v-show="list.vipBpmForMyAppDtoList[0].isLdentifying"
                    >
                      {{ $t('B018','拒绝') }}
                    </ld-button>
                  </van-col>

                  <van-col span="6">
                    <ld-button
                      main2
                      size="sm"
                      style="width:70px"
                      @click.native="approvalShow('Agree', list.vipBpmForMyAppDtoList[0])"
                    >
                      {{ list.vipBpmForMyAppDtoList[0].isLdentifying?$t('B017','同意'):$t('B067','确认') }}
                    </ld-button>
                  </van-col>
                </van-row>
              </approval-list-item>
            </mescroll-vue>
          </div>
        </van-tab>

        <van-tab
          name="7"
          v-if="index == 3"
        >
          <template #title>
            <span>审批中止</span>
            ({{ approvaledsuspendList.total }})
          </template>
          <div class="wrapper">
            <mescroll-vue :up="{ use: true, callback: onRefresh }">
              <approval-list-item
                :list="list"
                v-for="(list, i) in approvaledsuspendList"
                :key="i"
                @to-order-detail="toOrderDetail"
                @to-approval-detail="goApprovalingDetail"
              />
            </mescroll-vue>
          </div>
        </van-tab>



        <van-tab
          v-if="index == 1"
          name="3"
          :title="'待支付('+lingthList +')'"
        >
          <order-list
            :page="topayPage"
            :list="topayList"
            @get-list="getList"
            @to-order-detail="toOrderDetail"
            @cancel="cancel"
            @send-approval="sendApproval"
            @pay="pay"
          />
        </van-tab>


        <van-tab
          v-if="index == 1"
          name="4"
          :title="'待送审('+waitApprovalPage.total+')'"
        >
          <order-list
            :page="waitApprovalPage"
            :list="waitApprovalList"
            @get-list="getWaitApprovalList"
            @to-order-detail="toOrderDetail"
            @cancel="cancel"
            @send-approval="sendApproval"
            @pay="pay"
          />
        </van-tab>
        <van-tab
          name="2"
          v-else
        >
          <template #title>
            <span v-if="index == 2">审批历史</span>
            <span v-else-if="index == 3">已审批</span>
            ({{ approvaledPage.total }})
          </template>
          <div class="wrapper">
            <mescroll-vue
              :up="{ use: true, callback: onRefresh }"
            >
              <approval-list-item
                :list="list"
                v-for="(list, i) in approvaledList"
                :key="i"
                @to-order-detail="toOrderDetail"
                @to-approval-detail="goApprovalingDetail"
              >
                <div slot="footer" />
              </approval-list-item>
            </mescroll-vue>
          </div>
        </van-tab>

        <!--      v-if="index == 1"-->
        <van-tab
          name="2"
          v-if="false"
        >
          <template #title>
            审批中({{ approvaledPage.total }})
          </template>
          <div class="wrapper">
            <mescroll-vue :up="{ use: true, callback: onRefresh }">
              <approval-list-item
                :list="list"
                v-for="(list, i) in approvaledList"
                :key="i"
                @to-order-detail="toOrderDetail"
                @to-approval-detail="goApprovalingDetail"
              >
                <div slot="footer" />
              </approval-list-item>
            </mescroll-vue>
          </div>
        </van-tab>

        <van-tab
          v-if="index == 3"
          name="4"
          :title="'待送审('+waitApprovalPage.total+')'"
        >
          <order-list
            :page="waitApprovalPage"
            :list="waitApprovalList"
            @get-list="getWaitApprovalList"
            @to-order-detail="toOrderDetail"
            @cancel="cancel"
            @send-approval="sendApproval"
            @pay="pay"
          />
        </van-tab>
      </van-tabs>

      <!-- 拒绝审批 Dialog -->
      <van-dialog
        v-model="approvalReject.show"
        title="请输入你的审批意见："
        class="text-center"
        show-cancel-button
        @confirm="approval('Reject', 0)"
      >
        <van-field
          v-model="approvalReject.value"
          placeholder="不大于50字"
        />
      </van-dialog>

      <!-- 同意审批 Dialog -->
      <van-dialog
        v-model="approvalAgree.show"
        title="请输入你的审批意见："
        class="text-center"
        show-cancel-button
        @confirm="approval('Agree', 1)"
      >
        <van-field
          v-model="approvalAgree.value"
          :placeholder="$t('B017','同意')"
        />
      </van-dialog>
    </div>
    <div v-else class="noLoginApprovalList">
      <van-nav-bar
        title="我的待办"
        fixed
      />
      <van-empty image-size="100%">
        <img slot="image" src="~Assets/images/order/order-empty.png">
        <span slot="description" class="black">登录后可查看待办列表</span>
        <van-row type="flex" justify="center">
          <van-button plain class="linear-main1" to="/login" round>登录/注册</van-button>
        </van-row>
      </van-empty>
    </div>
  </div>
</template>

<script>
import { Panel, Collapse, CollapseItem, Tab, Tabs, List, Button, Field, PullRefresh,NavBar } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import Item from './Item'
import ldButton from 'Common/ldButton'
import Bussiness from 'Utils/business'
import ldStatusbar from 'Common/ldStatusbar'
import orderList from 'Views/Home/allorder/components/orderList'
import { getRelativeDate } from 'Utils/dateUtil'
import { mapActions, mapGetters } from 'vuex'
import { isGat, toPayForGat } from 'Utils/gattools';

export const ToPayParams = {
  dateStart: getRelativeDate(-30),
  dateEnd: getRelativeDate(0),
  dateType: '1', // 1 预订日期,2 是出发/入住日期
  findScope: '1', // 1是个人订单,2是全部订单 ,
  queryType: '1',// 1全部订单 2待支付 3待出行 4退改 5指定的业务订单（productType必须传值）
}

export default {
  name: 'ApprovalList',
  components: {
    [Panel.name]: Panel,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [Field.name]: Field,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [NavBar.name]: NavBar,
    ['approval-list-item']: Item,
    MescrollVue,
    ldButton,
    ldStatusbar,
    orderList
  },
  data () {
    return {
      lingthList:'0',
      index: 1, // 1. 待办   2. 需要我审批  3. 我提交的审批
      active: 1,
      approvalPage: {
        pageNum: 0,
        count: 10,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载',
        total:0
      },
      approvalList: [],
      approvaledPage: {
        pageNum: 0,
        count: 10,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载',
        total:0
      },
      approvaledList: [],
      approvalAgree: {
        value: '',
        show: false,
        item: {}
      },
      approvalReject: {
        value: '',
        show: false,
        item: {}
      },
      topayList: [],
      topayPage: {
        pageNum: 0,
        count: 20,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了 ~',
        error: false,
        errorText: '请求失败，点击重新加载',
        total:0
      },
      approvaledsuspendList:[],
      approvaledsuspendListPage: {
        pageNum: 0,
        count: 10,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载',
        total:0
      },
      waitApprovalList: [],
      waitApprovalPage: {
        pageNum: 0,
        count: 20,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了 ~',
        error: false,
        errorText: '请求失败，点击重新加载',
        total:0
      },
      pullRefreshLoading1: false,
      pullRefreshLoading2: false,
      pullRefreshLoading3: false,
    }
  },
  activated () {
    this.getBadgeCount()
  },
  created() {
    this.index = this.$route.query.index || 1
    if (this.index == 1) {
      this.topayPage.total = this.badgeDotCount.topay
      this.approvaledPage.total = this.badgeDotCount.approvaled
      this.waitApprovalPage.total = this.badgeDotCount.waitapproval
    } else if (this.index == 2) {
      this.getApprovalCount(0)
    } else if (this.index == 3) {
      this.getApprovalCount(1)
      this.waitApprovalPage.total = this.badgeDotCount.waitapproval
    }
    this.getList();
  },
  methods: {
    ...mapActions(['getBadgeCount']),
    async getApprovalCount(approveType) {
      const { data = {} } = await this.$api['approval/vipBpmForPendingMyAppCount']({
        approveType
      })

      if (this.index == 2) {
        this.approvaledPage.total = data.myAppHistoryCount
      } else if (this.index == 3) {
        this.approvaledPage.total = data.appHistoryCount
      }

    },
    onRefresh(page, mescroll) {
      if (this.active === '1') {
        this.getApprovalList(page, mescroll)
        this.getApprovaledsuspendList(page, mescroll)
      } else if(this.active === '2') {
        this.getApprovaledList(page, mescroll)
      } else if(this.active === '7') {
        this.getApprovaledsuspendList(page, mescroll)
      }else if(this.active === '3') {
        this.topayList = []
        this.topayPage.pageNum = 1
        this.getList(page, mescroll)
      } else {
        this.waitApprovalList = []
        this.waitApprovalPage.pageNum = 1
        this.getWaitApprovalList(page, mescroll)
      }
      this[`pullRefreshLoading${this.active}`] = false
    },
    // 获取待审批列表
    getApprovalList (page, mescroll) {
      let params = {
        pageNum: page.num,
        count: page.size,
        approveType: this.index == 3 ? 1 : 0
      }
      this.$api['approval/vipBpmForMyAppNew'](params).then(res => {
        var cache = res.data || {}
        var list = cache.list || []
        var newlist = []
        list.forEach(element => {
          let data = {
            orderId: element.vipBpmForMyAppDtoList[0].orderId,
            orderType: element.vipBpmForMyAppDtoList[0].orderType,
          }
          this.$api['approval/vipOrderAppProgress'](data).then(resp => {
            if(resp.errCode == 1) {
              const {spjdInfoList, spjd} = resp.data
              let spjdStop = parseInt(spjd.charAt(0)) - 1
              element.vipBpmForMyAppDtoList[0].isLdentifying = true
              if(spjdInfoList[spjdStop].jblx == 1) {
                element.vipBpmForMyAppDtoList[0].isLdentifying = false
                if(element.vipBpmForMyAppDtoList[0].orderStatusRemark) {
                  let index = element.vipBpmForMyAppDtoList[0].orderStatusRemark.indexOf('|')
                  element.vipBpmForMyAppDtoList[0].orderStatusRemark = element.vipBpmForMyAppDtoList[0].orderStatusRemark.substr(0, index + 1) + '确认中'
                }
              }
              newlist.push(element)
            }
          })
        })
        if(list) {
          if(cache.pageNum > 1) {
            this.approvalList.push(...newlist)
          } else if(cache.pageNum == 1) {
            this.approvalList = newlist
          }
        }
        this.approvalPage.total = cache.total
        // this.badgeDotCount()
        // 数据渲染成功后,隐藏下拉刷新的状态
        this.$nextTick(() => {
          mescroll && mescroll.endSuccess(list.length, cache.total)
        })
      }).catch(() => {
        // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
        mescroll && mescroll.endErr()
      })
    },
    // 获取已审批列表
    getApprovaledList (page, mescroll) {
      let params = {
        pageNum: page.num,
        count: page.size,
        approveType: this.index == 2 ? 0 : 1
      }
      let url = this.index == 1 ? 'approval/vipBpmForMyAppNew' : 'approval/vipBpmForMyAppedNew'
      this.$api[url](params).then(res => {
        var cache = res.data||{}
        var list = cache.list||[]
        if (list.length) {
          if (cache.pageNum > 1) {
            this.approvaledList.push(...list)
          } else {
            this.approvaledList = list
          }
        }

        this.approvaledPage.total = cache.total
        if (cache.total == 0) {
          this.approvaledPage.finished = true
        }

        this.badgeDotCount()

        // 数据渲染成功后,隐藏下拉刷新的状态
        this.$nextTick(() => {
          mescroll && mescroll.endSuccess(list.length, cache.total)
        })
      }).catch(() => {
        // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
        mescroll && mescroll.endErr()
      })
    },
    // 获取可中止的列表
    getApprovaledsuspendList (page, mescroll) {
      let params = {
        pageNum: page.num,
        count: page.size,
        approveType: 3
      }
      let url = 'approval/vipBpmForMyAppedNew'
      this.$api[url](params).then(res => {
        var cache = res.data||{}
        var list = cache.list||[]
        if (list.length) {
          if (cache.pageNum > 1) {
            this.approvaledsuspendList.push(...list)
          } else {
            this.approvaledsuspendList = list
          }
        }

        this.approvaledsuspendList.total = cache.total
        if (cache.total == 0) {
          this.approvaledsuspendList.finished = true
        }
        this.badgeDotCount()

        // 数据渲染成功后,隐藏下拉刷新的状态
        this.$nextTick(() => {
          mescroll && mescroll.endSuccess(list.length, cache.total)
        })
      }).catch(() => {
        // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
        mescroll && mescroll.endErr()
      })
    },

    approvalShow (type, item) {
      this[`approval${type}`].show = true
      this[`approval${type}`].item = item
    },
    // 送审操作
    approval (type, completeState) {
      let params = {
        appRemark: this[`approval${type}`].value,
        completeState,
        completeWay: 2,
        workItemId: this[`approval${type}`].item.workItemId
      }
      this.$api['approval/vipBpmReceiveAppResult'](params).then(() => {
        this.$dialog({ message: '审批成功' })
        this[`approval${type}`].value = ''
        this.getApprovalList({ num: 1, size: 10 })
        this.getApprovaledList({ num: 1, size: 10 })
        this.getBadgeCount()
      })
    },
    //去审批详情页面
    goApprovalingDetail (id, workItemId, orderType) {
      if(this.index == 3) {
        Bussiness.toOrderDetail({id, orderType})
      } else {
        this.$router.push({
          path: '/approval/Detail', query: {
            id, workItemId, orderType,
            active: this.active
          }
        })
      }
    },
    //去订单详情
    toOrderDetail (id, workItemId, orderType) {
      if (typeof id === 'string') {
        Bussiness.toOrderDetail({id, orderType})
      } else {
        Bussiness.toOrderDetail(id)
      }
    },
    getList() { // 获取列表
      if (this.topayPage.pageNum == 0) {
        this.topayPage.pageNum = 1
      }
      this.$api['common/allOrderList']({
        pageNum: this.topayPage.pageNum,
        count: this.topayPage.count,
        findType: '2',
        ...ToPayParams
      }).then(res => {
        this.topayPage.loading = false
        const cache = res.data || {}
        if(res.data.list){
          this.lingthList = res.data.list.length
        } else {
          this.lingthList = 0
        }
        if (cache.list) {
          if (cache.list.length < this.topayPage.count) {
            this.topayPage.finished = true
          } else {
            this.topayPage.finished = false
          }
          if (cache.pageNum > 1) {
            this.topayList.push(...cache.list)
          } else {
            this.topayList = cache.list
          }
        } else if (!cache.list && this.topayPage.pageNum == 1) {
          this.topayList = []
          this.topayPage.finished = true
        } else {
          this.topayPage.finished = true
        }
        if (cache.total == 0) {
          this.topayPage.finished = true
        }
        this.topayPage.total = cache.total
        this.getBadgeCount()
      }).catch(() => {
        this.topayPage.error = true
      })

    },
    sendApproval(detail) { // 送审
      Bussiness.ApprovalSend(detail)
    },
    async cancel(item) { // 取消订单
      if(item.orderType=='11018'&&!item.value){
        this.$api['carOrder/getCancelFee']({
          orderId:item.id
        }).then(res => {
          let cache=res.data||{}
          if(cache.khFine){
            this.$dialog.confirm({
              title:'提示',
              message:'取消订单会产生罚金￥'+cache.khFine+'，是否继续取消订单？',
            }).then(() => {
              this.$refs.cancelRason.toggle()
            }).catch(() => {
              // on cancel
            })
          }else{
            this.$dialog.confirm({
              title:'提示',
              message:'是否取消订单',
            }).then(() => {
              this.$refs.cancelRason.toggle()
            }).catch(() => {
              // on cancel
            })
          }
        }).catch(res =>{
          this.$toast(res.errMsg)
        })
        return
      }
      await Bussiness.toOrderCancel(item)
      this.getList()
    },
    pay(item) { // 支付
      // 关爱通支付
      if (isGat()) {
        return toPayForGat(item.id, item.orderType);
      }
      this.$router.push({path:'/pay/payment',query:{orderType:item.orderType,orderId:item.id}})
    },
    getWaitApprovalList() { // 获取列表
      if (this.waitApprovalPage.pageNum == 0) {
        this.waitApprovalPage.pageNum = 1
      }
      this.$api['common/totalOrderList']({
        pageNum: this.waitApprovalPage.pageNum,
        count: this.waitApprovalPage.count,
        findType: '5',
        ...ToPayParams
      }).then(res => {
        this.waitApprovalPage.loading = false
        const cache = res.data || {}
        if (cache.list) {
          if (cache.list.length < this.waitApprovalPage.count) {
            this.waitApprovalPage.finished = true
          } else {
            this.waitApprovalPage.finished = false
          }
          if (cache.pageNum > 1) {
            this.waitApprovalList.push(...cache.list)
          } else {
            this.waitApprovalList = cache.list
          }
        } else if (!cache.list && this.waitApprovalPage.pageNum == 1) {
          this.waitApprovalList = []
          this.waitApprovalPage.finished = true
        } else {
          this.waitApprovalPage.finished = true
        }
        if (cache.total == 0) {
          this.waitApprovalPage.finished = true
        }
        this.waitApprovalPage.total = cache.total
        this.getBadgeCount()
      }).catch(() => {
        this.waitApprovalPage.error = true
      })
    },
    changeTab(){
      if (this.active == 3) {
        this.getList()
      } else if (this.active == 4) {
        this.getWaitApprovalList()
      }
    },

  },
  computed: {
    ...mapGetters(['badgeDotCount', 'userInfo']),
    totalCount () {
      this.$store.state.app.badgeDotCount.topay=this.lingthList
      return parseInt(this.approvalPage.total) + parseInt(this.approvaledPage.total) + parseInt(this.topayPage.total) + parseInt(this.waitApprovalPage.total)
    }
  }
}
</script>

<style lang="less" scoped>
.approvalList {
  .mescroll{
    height: calc(100vh - 94px);
  }

  .van-tab__pane {
    font-size: @font-size-12;
    padding: 0 8px 60px;
  }
}
.noLoginApprovalList{
	height:100vh;
	background-color:#fff;
}
</style>
